import React from "react"

import { Heading, SEO } from "../components"
import { Leif } from "../components/leif";
import {
  safelyGetFrontMatter,
  withFallback,
} from "../cms"

export const LeifPageTemplate = props => {
  const { title } = props;
  return (
    <article>
      <SEO title={title} />
      <Leif {...props}/>
    </article>
  );
}

const LeifPage = ({ pageContext, location }) => {
  return (
    <LeifPageTemplate
      location={location}
      {...safelyGetFrontMatter(pageContext)}
      isPreview={false}
    />
  )
}

export default LeifPage
